import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import SAECSScheduleView from './components/SAECSScheduleView';
import ProteaScheduleView from './components/ProteaScheduleView';
import SafariScheduleView from './components/SafariScheduleView';
import MesawaScheduleView from './components/MesawaScheduleView';
import VesselSearch from './components/VesselSearch';
import PerformanceDashboard from './components/PerformanceDashboard';
import Footer from './components/Footer';
import { ThemeProvider } from './context/ThemeContext';

function App() {
  return (
    <ThemeProvider>
      <Router>
        {/* Main container */}
        <div className="min-h-screen bg-gray-100 dark:bg-gray-900 transition-colors duration-200 flex flex-col">
          <Navigation />
          <main className="container mx-auto px-4 py-8 flex-grow">
            <Routes>
              <Route path="/" element={<SAECSScheduleView />} />
              <Route path="/protea" element={<ProteaScheduleView />} />
              <Route path="/safari" element={<SafariScheduleView />} />
              <Route path="/mesawa" element={<MesawaScheduleView />} />
              <Route path="/search" element={<VesselSearch />} />
              <Route path="/performance" element={<PerformanceDashboard />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
